export default "__VITE_ASSET__DXGnFjkD__"